import React, { Component } from 'react';

//Import AOS animation
import AOS from 'aos';
import '../../../node_modules/aos/dist/aos.css';


//Import Components
// import Section from "./section";
import Features from "./features";
// import Process from "./process";
import ModalVideoSection from "./modal-video";
// import Shape from "./shape";
import Testimonials from "./testimonials";
// import Partners from "../../components/Shared/Partners";
// import Price from "./price";
import Download from "./download";
import Install from "./install";
import ContactUs from "./contact-us";

//Import Images
// import client1 from "../../images/client/01.jpg";
// import client2 from "../../images/client/02.jpg";
// import client3 from "../../images/client/03.jpg";
// import client4 from "../../images/client/04.jpg";
// import client5 from "../../images/client/05.jpg";
// import client6 from "../../images/client/06.jpg";

//Import Images
// import img1 from "../../images/client/01.jpg";
// import img2 from "../../images/client/02.jpg";
// import img3 from "../../images/client/03.jpg";
// import img4 from "../../images/client/04.jpg";
// import img5 from "../../images/client/05.jpg";
// import img6 from "../../images/client/06.jpg";

// Blog Images
// import blog1 from '../../images/blog/01.jpg';
// import blog2 from '../../images/blog/02.jpg';
// import blog3 from '../../images/blog/03.jpg';

// const client = {
//     reviews : [
//         { id : 1, img : img1, name : "Thomas Israel", post : "C.E.O", desc : "It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.", rating : 5 },
//         { id : 2, img : img2, name : "Barbara McIntosh", post : "M.D", desc : "One disadvantage of Lorum Ipsum is that in Latin certain letters appear more frequently than others.", rating : 4 },
//         { id : 3, img : img3, name : "Carl Oliver", post : "P.A", desc : "The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century.", rating : 3 },
//         { id : 4, img : img4, name : "Christa Smith", post : "Manager", desc : "According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero.", rating : 5 },
//         { id : 5, img : img5, name : "Dean Tolle", post : "Developer", desc : "There is now an abundance of readable dummy texts. These are usually used when a text is required.", rating : 5 },
//         { id : 6, img : img6, name : "ill Webb", post : "Designer", desc : "Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts.", rating : 4 },
//     ],
//     blogs : [
//         { id : 1, image : blog1, title : "Design your apps in your own way", like : "33", comment : "08", autor : "Calvin Carlo", date : "13th August, 2019" },
//         { id : 2, image : blog3, title : "How apps is changing the IT world", like : "33", comment : "08", autor : "Calvin Carlo", date : "13th August, 2019" },
//         { id : 3, image : blog2, title : "Smartest Applications for Business", like : "33", comment : "08", autor : "Calvin Carlo", date : "13th August, 2019" },
//     ]
// }

class SaasOnepage extends Component {
    tawkToPropertyId = '5ef1745c4a7c6258179b2583';
    tawkChatId = 'default';

    constructor(props, context) {
        super(props, context);
        //Initilize Aos Animation
        AOS.init();
    }

    componentDidMount() {
        //Refresh Aos Animation whenever components will render
        AOS.refresh();
        this.loadTawk(this.tawkToPropertyId, this.tawkChatId);

        document.body.classList = "";
        window.addEventListener("scroll", this.scrollNavigation, true);

        //set AOS atttributes to section title and desc
        var elementsTitle = document.getElementsByName("sectiontitle");
        var elementsDesc = document.getElementsByName("sectiondesc");

        for (var i = 0; i < elementsTitle.length; i++) {
            elementsTitle[i].setAttribute("data-aos", "fade-up");
            elementsTitle[i].setAttribute("data-aos-duration", "1200");
            elementsDesc[i].setAttribute("data-aos", "fade-up");
            elementsDesc[i].setAttribute("data-aos-duration", "1000");
        }

        //set AOS atttributes to slider <Media> tags
        var elements = document.getElementsByName("clientsreview");
        for (var j = 0; j < elements.length; j++) {
            elements[j].setAttribute("data-aos", "fade-up");
            elements[j].setAttribute("data-aos-duration", "1800");
        }

        //set AOS atttributes to Features
        var features = document.getElementsByName("featurebox");
        for (var f = 0; f < features.length; f++) {
            features[f].setAttribute("data-aos", "fade-up");
            features[f].setAttribute("data-aos-duration", "1800");
        }

        //set AOS atttributes to partners
        // for(var k=1; k<=6;k++){
        //     document.getElementById("partner"+k).setAttribute("data-aos", "fade-up");
        //     document.getElementById("partner"+k).setAttribute("data-aos-duration", "1800");
        // }

        //set AOS atttributes to pricing
        var pricing = document.getElementsByName("pricing");
        for (var a = 0; a < pricing.length; a++) {
            pricing[a].setAttribute("data-aos", "fade-up");
            pricing[a].setAttribute("data-aos-duration", "1400");
        }

        //set AOS atttributes to team
        var team = document.getElementsByName("team");
        for (var b = 0; b < team.length; b++) {
            team[b].setAttribute("data-aos", "fade-up");
            team[b].setAttribute("data-aos-duration", "1200");
        }

        //set AOS atttributes to footer
        var footer = document.getElementsByName("footercolumn");
        for (var fcol = 0; fcol < footer.length; fcol++) {
            footer[fcol].setAttribute("data-aos", "fade-up");
            footer[fcol].setAttribute("data-aos-duration", "1400");
        }
    }

    // Make sure to remove the DOM listener when the component is unmounted.
    componentWillUnmount() {
        window.removeEventListener("scroll", this.scrollNavigation, true);
    }

    scrollNavigation = () => {
        var doc = document.documentElement;
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (top > 80) {
            document.getElementById('topnav').classList.add('nav-sticky');
        }
        else {
            document.getElementById('topnav').classList.remove('nav-sticky');
        }
    }

    loadTawk = (propertyID, chatID) => {
        var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date(); Tawk_API.embedded=`tawk_${propertyID}`;
        (function(){
        var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
        s1.async=true;
        s1.src=`https://embed.tawk.to/${propertyID}/${chatID}`;
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s0.parentNode.insertBefore(s1,s0);})();
    }

    render() {
        return (
            <React.Fragment>
                <section className="section pb-0" id="home">
                    {/* modal Video */}
                    <ModalVideoSection />
                </section>

                <section className="section pb-0" id="features">
                    {/* features */}
                    <Features />

                    {/* process */}
                    {/* <Process/> */}
                </section>
                <section className="section bg-light" id="reviews">
                    {/* testimonials */}
                    <Testimonials />

                    {/* <Container className="pt-5"> */}
                        {/* partners */}
                        {/* <Partners />   */}
                    {/* </Container>     */}
                </section>

                <section className="section pb-0" id="demo">
                    {/* download demo */}
                    <Download />

                    {/* <Shape /> */}

                </section>
                

                <section className="section pb-0" id="buy">                  
                    {/* contact us */}
                    <ContactUs />


                </section>

                <section className="section pb-0" id="setup">
                    {/* install demo */}
                    <Install />
                </section>
            </React.Fragment>
        );
    }
}

export default SaasOnepage;